(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-teaser"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-tt-teaser]');
    if (!root) return;

    // 背景：ゆっくりしたクロスフェードで切替
    var slides = root.querySelectorAll('[data-tt-slide]');
    var wrap = root.querySelector('[data-tt-slides]');
    var interval = (parseInt(wrap.getAttribute('data-interval'), 10) || 9) * 1000;
    // iPhone Safari（iOS 26）の上下バーは body の背景色 1 色で塗られる（theme-color は効かない。2026-09-18 実機スクショで確認）。
    // スライドごとに body の色を変え、同じ色へ画面の上端・下端を溶かす（.tt-teaser__edge）ことで帯の境目を消す
    var edge = ['#030303'];
    var meta = document.querySelector('meta[name="theme-color"]');
    function tint(i) { var c = edge[i] || edge[0]; if (meta) meta.setAttribute('content', c); document.documentElement.style.backgroundColor = c; document.body.style.backgroundColor = c; root.style.setProperty('--tt-edge', c); }
    document.documentElement.style.transition = document.body.style.transition = 'background-color 3.2s ease-in-out';
    tint(0);
    function show(next) { slides.forEach(function (x, i) { x.classList.toggle('is-active', i === next); }); tint(next); }
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slides.length > 1) {
      var idx = 0;
      // 冒頭の演出のぶん、最初の切り替えだけ遅らせる
      setTimeout(function () { setInterval(function () { idx = (idx + 1) % slides.length; show(idx); }, interval); }, reduceMotion ? 0 : 7000);
    }

    // 冒頭の演出：黒から光が広がる＋文字の出現。1 枚目の画像が読めてから始める（最長 1.2 秒で見切る）
    var intro = root.querySelector('[data-tt-intro]');
    if (intro && !reduceMotion) {
      root.classList.add('is-intro');
      [].forEach.call(root.querySelectorAll('.tt-teaser__unit'), function (u, i) { u.style.setProperty('--i', i); });
      var first = slides[0] && slides[0].querySelector('img'), started = false, ttl = root.querySelector('.tt-teaser__title'), ttlAnim = null;
      var reveal = function () {
        // 見出し：行ごとに座布団（帯）が左から走り、覆った瞬間にその行の文字を出して、右へ抜ける
        if (!ttl || !ttl.animate) { if (ttl) ttl.style.clipPath = 'none'; return; }
        var wrap = document.createElement('div'); wrap.className = 'tt-rv'; ttl.parentNode.insertBefore(wrap, ttl); wrap.appendChild(ttl);
        var base = ttl.getBoundingClientRect(), lines = [];
        [].forEach.call(ttl.childNodes, function (n) { if (n.nodeType !== 3 || !n.textContent.trim()) return; var r = document.createRange(); r.selectNodeContents(n); lines.push(r.getBoundingClientRect()); });
        if (!lines.length) { ttl.style.clipPath = 'none'; return; }
        var T0 = 900, G = 240, D = 1100, total = T0 + (lines.length - 1) * G + D, kf = [{ clipPath: 'inset(0 -6% 100% -6%)', offset: 0, easing: 'step-end' }];
        lines.forEach(function (r, i) {
          var b = document.createElement('i'); b.className = 'tt-rv__b';
          b.style.top = (r.top - base.top) + 'px'; b.style.height = r.height + 'px'; b.style.left = (r.left - base.left - 6) + 'px'; b.style.width = (r.width + 12) + 'px';
          b.style.animationDelay = (T0 + i * G) + 'ms'; wrap.appendChild(b);
          var hide = Math.max(0, (base.bottom - r.bottom) / base.height * 100);
          kf.push({ clipPath: 'inset(0 -6% ' + (i === lines.length - 1 ? 0 : hide).toFixed(2) + '% -6%)', offset: (T0 + i * G + D * 0.5) / total, easing: 'step-end' });
        });
        kf.push({ clipPath: 'inset(0 -6% 0% -6%)', offset: 1 });
        ttlAnim = ttl.animate(kf, { duration: total, fill: 'forwards' });
      };
      var go = function () {
        if (started) return; started = true;
        requestAnimationFrame(function () { intro.classList.add('is-go'); root.classList.add('is-intro-go', 'is-cta'); reveal(); });
        // 片付け：出現が終わったら素の状態に戻す（最終状態＝素のスタイル）
        setTimeout(function () {
          root.classList.remove('is-intro', 'is-intro-go'); if (ttlAnim) ttlAnim.cancel(); if (ttl) ttl.style.clipPath = '';
          [].forEach.call(root.querySelectorAll('.tt-rv__b'), function (b) { b.remove(); });
        }, 7600);
      };
      intro.addEventListener('animationend', function (e) { if (e.target === intro) intro.remove(); });
      if (!first || first.complete) go(); else { first.addEventListener('load', go); first.addEventListener('error', go); }
      setTimeout(go, 1200);
    } else if (intro) { intro.remove(); }
    // ---- さりげない演出：ゆっくりした拡大 / マウス追従の視差・ピント・光 / 舞う粒子
    var bg = root.querySelector('.tt-teaser__bg');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slides.forEach(function (sl, i) {
      var media = sl.querySelector('picture') || sl.querySelector('img');
      var kb = document.createElement('div'); kb.className = 'tt-teaser__kb';
      kb.style.animationDelay = (-i * 11) + 's';
      sl.insertBefore(kb, media); kb.appendChild(media); media.classList.add('tt-teaser__soft');
      var sharp = media.cloneNode(true); sharp.classList.remove('tt-teaser__soft'); sharp.classList.add('tt-teaser__sharp'); kb.appendChild(sharp);
    });
    var tx = 0, ty = 0, cx = 0, cy = 0, fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches, t0 = performance.now();
    var cur = root.querySelector('[data-tt-cursor]'), title = root.querySelector('.tt-teaser__title'), px = -100, py = -100, gyro = false;
    if (fine) {
      title.classList.add('is-follow');
      window.addEventListener('pointermove', function (e) { tx = (e.clientX / innerWidth) * 2 - 1; ty = (e.clientY / innerHeight) * 2 - 1; px = e.clientX; py = e.clientY;
        if (cur) { cur.style.transform = 'translate3d(' + px + 'px,' + py + 'px,0)'; cur.classList.toggle('is-link', !!(e.target.closest && e.target.closest('a,button'))); } }, { passive: true });
      document.addEventListener('mouseleave', function () { if (cur) cur.style.transform = 'translate3d(-100px,-100px,0)'; });
    } else if (window.DeviceOrientationEvent) {
      // 3. スマホを傾けると視差が動く
      var onTilt = function (e) { if (e.gamma == null) return; gyro = true; tx = Math.max(-1, Math.min(1, e.gamma / 25)); ty = Math.max(-1, Math.min(1, (e.beta - 45) / 30)); };
      // iOS は許可ダイアログが出るため傾き連動を使わない（自動の漂いのまま）。許可不要の端末だけ連動
      if (typeof DeviceOrientationEvent.requestPermission !== 'function') window.addEventListener('deviceorientation', onTilt);
    }
    // 粒子
    var cv = root.querySelector('[data-tt-dust]'), ctx = cv && cv.getContext('2d'), P = [], dpr = Math.min(window.devicePixelRatio || 1, 2);
    function size() { if (!cv) return; cv.width = innerWidth * dpr; cv.height = innerHeight * dpr; }
    function seed() { P = []; var n = Math.round(Math.min(70, innerWidth / 22)); for (var i = 0; i < n; i++) P.push({ x: Math.random(), y: Math.random(), z: Math.random(), r: 0.5 + Math.random() * 1.6, a: 0.05 + Math.random() * 0.22, ph: Math.random() * 6.28, sp: 0.004 + Math.random() * 0.010 }); }
    size(); seed(); window.addEventListener('resize', function () { size(); seed(); });
    var last = performance.now(), flick = 0;
    function frame(now) {
      var dt = Math.min(0.05, (now - last) / 1000); last = now;
      if (!fine && !gyro) { var t = (now - t0) / 1000; tx = Math.sin(t / 7) * 0.5; ty = Math.cos(t / 9) * 0.4; } // スマホはゆっくり自動で漂う
      cx += (tx - cx) * 0.045; cy += (ty - cy) * 0.045;
      if (fine && title) title.style.backgroundPosition = ((1 - (cx + 1) / 2) * 100).toFixed(2) + '% 50%';
      // ライト：呼吸（周期の合わない波の重ね）＋ごく弱い不規則なゆらぎ
      var ts = now / 1000; flick += ((Math.random() < 0.035 ? (Math.random() - 0.5) * 0.22 : 0) - flick) * 0.12;
      var lo = 0.78 + 0.13 * Math.sin(ts * 0.55) + 0.07 * Math.sin(ts * 1.37 + 1.3) + 0.04 * Math.sin(ts * 3.1 + 0.4) + flick;
      bg.style.setProperty('--lo', Math.max(0.45, Math.min(1, lo)).toFixed(3));
      // 光の呼吸：約 6.5 秒の主周期に、合わない 2 波を重ねる。強さ（--bo）と大きさ（--bs）を同時に動かす
      var br = 0.5 + 0.5 * Math.sin(ts * 0.97 - 1.2), br2 = 0.5 + 0.5 * Math.sin(ts * 0.41 + 0.7), br3 = 0.5 + 0.5 * Math.sin(ts * 2.3);
      var bo = 0.36 + 0.32 * br + 0.12 * br2 + 0.04 * br3 + flick * 0.35, bs = 0.90 + 0.24 * br + 0.07 * br2;
      bg.style.setProperty('--bo', Math.max(0.30, Math.min(0.92, bo)).toFixed(3)); bg.style.setProperty('--bs', bs.toFixed(3));
      bg.style.setProperty('--mx', cx.toFixed(4)); bg.style.setProperty('--my', cy.toFixed(4));
      bg.style.setProperty('--fx', ((cx + 1) * 50).toFixed(2) + '%'); bg.style.setProperty('--fy', ((cy + 1) * 50).toFixed(2) + '%');
      if (ctx) {
        ctx.clearRect(0, 0, cv.width, cv.height);
        for (var i = 0; i < P.length; i++) { var p = P[i];
          p.y -= p.sp * dt * (0.5 + p.z); p.ph += dt * (0.3 + p.z * 0.5); if (p.y < -0.05) { p.y = 1.05; p.x = Math.random(); }
          var x = (p.x + Math.sin(p.ph) * 0.012 - cx * 0.02 * (0.3 + p.z)) * cv.width, y = (p.y - cy * 0.015 * (0.3 + p.z)) * cv.height, r = p.r * dpr * (0.6 + p.z * 1.6);
          var g = ctx.createRadialGradient(x, y, 0, x, y, r * 2.4); g.addColorStop(0, 'rgba(255,238,220,' + (p.a * (0.6 + 0.4 * Math.sin(p.ph * 1.7))).toFixed(3) + ')'); g.addColorStop(1, 'rgba(255,238,220,0)');
          ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, r * 2.4, 0, 6.2832); ctx.fill(); }
      }
      requestAnimationFrame(frame);
    }
    if (!reduce) requestAnimationFrame(frame);

    // © をクリックでパスワード入力ダイアログ（関係者確認用）
    var staff = root.querySelector('[data-tt-staff]');
    var dlg = document.querySelector('#password-form dialog');
    if (staff && dlg) staff.addEventListener('click', function () { if (!dlg.open) dlg.showModal(); });

    // カウントダウン
    var cd = root.querySelector('[data-tt-countdown]');
    var target = new Date(cd.getAttribute('data-launch')).getTime();
    var el = { d: cd.querySelector('[data-tt-d]'), h: cd.querySelector('[data-tt-h]'), m: cd.querySelector('[data-tt-m]'), s: cd.querySelector('[data-tt-s]') };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var s = Math.floor(diff / 1000);
      var vals = { d: String(Math.floor(s / 86400)), h: pad(Math.floor((s % 86400) / 3600)), m: pad(Math.floor((s % 3600) / 60)), s: pad(s % 60) };
      ['d', 'h', 'm', 's'].forEach(function (k) { if (el[k].textContent !== vals[k]) el[k].textContent = vals[k]; });
    }
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
